import api from './api';

// Update a single gantt task
// PUT /projects/{projectId}/gantt/tasks/{taskId}
export async function updateGanttTask(projectId, taskId, payload) {
  if (!projectId) throw new Error('updateGanttTask: projectId is required');
  if (!taskId) throw new Error('updateGanttTask: taskId is required');
  const url = `/projects/${projectId}/gantt/tasks/${taskId}`;
  const res = await api.put(url, payload);
  return res?.data;
}

// Update task by ID using unified Tasks API
// PUT /tasks/{id}
export async function updateTaskById(taskId, payload) {
  if (!taskId) throw new Error('updateTaskById: taskId is required');
  const url = `/tasks/${taskId}`;
  const res = await api.put(url, payload);
  return res?.data;
}

// Delete task by ID using unified Tasks API
// DELETE /tasks/{id}
export async function deleteTaskById(taskId) {
  if (!taskId) throw new Error('deleteTaskById: taskId is required');
  const url = `/tasks/${taskId}`;
  const res = await api.delete(url);
  return res?.data;
}

// Create a new task under a work category
// POST /work-categories/{workCategoryId}/tasks
// Expected payload example:
// {
//   name: string,
//   startDate: 'YYYY-MM-DD',
//   endDate: 'YYYY-MM-DD',
//   duration: number,
//   progress: number,
//   quantity: number|string,
//   completedQuantity: number,
//   unit: string,
//   unitPrice: number|string,
//   autoCalculateWeight: boolean,
//   weight: number|string,
//   notes: string,
//   assignedTo: number|string|null, // installation team id
//   dependencies: [{ taskId: string, type: 'FS'|'SS'|'FF'|'SF', lag: number }],
//   isMilestone: boolean,
//   displayOrder: number,
//   masterJobId: number|null,
//   jobCode: string|null,
//   status: 'to_do'|'in_progress'|'done',
//   workCategoryId: number
// }
export async function createTask(workCategoryId, payload) {
  if (!workCategoryId) throw new Error('createTask: workCategoryId is required');
  const url = `/work-categories/${workCategoryId}/tasks`;
  const res = await api.post(url, payload);
  return res?.data;
}

// Split an existing task into two parts
// POST /projects/{projectId}/gantt/tasks/{taskId}/split
// Expected payload example:
// {
//   splitDate: 'YYYY-MM-DD',
//   resumeDate: 'YYYY-MM-DD',
//   task2EndDate: 'YYYY-MM-DD',
//   task1Progress: number, // 0..1
//   task2Progress: number, // 0..1
//   task1Quantity: number,
//   task2Quantity: number,
//   task1Name: string,
//   task2Name: string,
//   namingFormat: 'fase'|'split'|'bagian'|'status',
//   reason: string
// }
export async function splitTask(projectId, taskId, payload) {
  if (!projectId) throw new Error('splitTask: projectId is required');
  if (!taskId) throw new Error('splitTask: taskId is required');
  const url = `/projects/${projectId}/gantt/tasks/${taskId}/split`;
  const res = await api.post(url, payload);
  return res?.data;
}

const ganttService = {
  updateGanttTask,
  updateTaskById,
  deleteTaskById,
  createTask,
  splitTask,
};

export default ganttService;
